import React from 'react';
import { Box, Stack, styled, Typography } from '@mui/material';
import { BookingPaymentState } from 'common/modules/bookings';
import { getBookingPaymentStateLabel } from '../utils';
import { useTranslation } from 'services/localization';

export interface Props {
	paymentState: BookingPaymentState;
}
const BookingPaymentStateBadge = (props: Props) => {
	const { t } = useTranslation();
	const { paymentState } = props;

	const renderStatusBubble = () => {
		switch (paymentState) {
			case 'PAID':
				return <StatusBubble sx={{ bgcolor: (theme) => theme.palette.success.main }} />;
			case 'UNPAID':
				return <StatusBubble sx={{ bgcolor: (theme) => theme.palette.error.main }} />;
			case 'REFUNDED':
				return <StatusBubble sx={{ bgcolor: (theme) => theme.palette.colors.tundra.light }} />;
		}
	};

	return (
		<Stack direction="row" alignItems="center" spacing={1}>
			{renderStatusBubble()}
			<Typography variant="body1" fontSize="1.4rem" lineHeight="22px">
				{getBookingPaymentStateLabel(paymentState, t)}
			</Typography>
		</Stack>
	);
};

const StatusBubble = styled(Box)({
	width: '10px',
	height: '10px',
	borderRadius: '50%',
});

export default BookingPaymentStateBadge;
